import React from 'react';

import ActionTileView from '../ActionTile.View';
import {NewGameActionModel} from './NewGameAction.model';

export default React.memo(function NewGameActionView({
  label,
  hint,
  disabled,
  onPress,
}: NewGameActionModel) {
  return (
    <ActionTileView
      testID="v2-action-new-game"
      icon="plus"
      label={label}
      hint={hint}
      disabled={disabled}
      onPress={onPress}
    />
  );
});
